import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, Optional, inject } from '@angular/core';
import { appConfigService, AppConfig } from '@app/config';
import { DynamicFormService } from '@ntap/common';
import {
  AuthRequestOptions,
  DataSource,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ServerItemAction,
  ViewWindow
} from '@ntap/core';
import { Observable, first, map, switchMap, take, tap } from 'rxjs';

@Component({
  selector: 'app-export-agent-data-action',
  templateUrl: './export-agent-data-action.component.html'
})
export class ExportAgentDataActionComponent
  extends ServerItemAction
  implements OnInit
{
  private httpClient = inject(HttpClient);

  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional() protected dynamicFormService: DynamicFormService,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    @Optional() protected override window: ViewWindow,
    @Inject(appConfigService) private config: AppConfig
  ) {
    super(notificationService, itemProvider, dataSource, listViewProvider);
    this.config = config;
  }

  enabled$: Observable<boolean>;

  ngOnInit(): void {
    if (this.listViewProvider) {
      this.enabled$ = this.listViewProvider?.selectedItems$.pipe(
        map((selected) => selected.length > 0 && selected.length < 50)
      );
    }
  }

  public downloadAgentXml() {
    this.listViewProvider.selectedItems$
      .pipe(
        take(1),
        switchMap((selectedItems: any[]) => {
          const agentIds = selectedItems.map((a) => a['en~agent~id']);

          return this.httpClient
            .post(`${this.config.apiHost}export-data/agents`, agentIds, {
              responseType: 'blob',
              observe: 'response',
              headers: new AuthRequestOptions().headers,
              withCredentials: true
            })
            .pipe(
              first(),
              tap((response: any) => {
                const blob = new Blob([response.body], {
                  type: 'application/xml'
                });
                const url = window.URL.createObjectURL(blob);

                const datetime = new Date().toISOString().replace(/:/g, '-');

                const link = document.createElement('a');
                link.href = url;
                link.download = `osobe_${datetime}.xml`;

                document.body.appendChild(link);
                link.click();

                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);

                const message =
                  agentIds.length > 1
                    ? 'Osobe uspješno preuzete'
                    : 'Osoba uspješno preuzeta';
                this.notificationService.success(message);
              })
            );
        })
      )
      .subscribe({
        error: (error) => {
          console.error('Error exporting agents:', error);
          this.notificationService.error('Failed to export agents.');
        }
      });
  }
}
